var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6133 22.3867-50 50-50h300c27.613 0 50 22.3867 50 50v320z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 300h399.996v179.996h-399.996z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6133 22.3867-50 50-50h300c27.613 0 50 22.3867 50 50v320z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6133 22.3867-50 50-50h300c27.613 0 50 22.3867 50 50v320z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 0h400v300h-400z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.926l107.074-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#3098d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6133 22.3867-50 50-50h300c27.613 0 50 22.3867 50 50v320zm-4.141-10 104.145-104.141v-315.859c0-22.0547-17.945-40-40-40h-300c-22.0547 0-40 17.9453-40 40v380c0 22.055 17.9453 40 40 40z",
    fill: "#2c8ac4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.352 384.973 96.793-96.793v96.793z",
    fill: "#2c8ac4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 370h-60c-27.613 0-50 22.387-50 50v60h110z",
    fill: "#97ccec"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    fill: "#fff",
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108.105 406.801v-35.641h4.922c5.098 0 9.286 1.395 12.571 4.176 3.281 2.785 4.922 7.43 4.922 13.934 0 3.777-.793 7.121-2.375 10.035-1.582 2.918-3.875 4.894-6.875 5.937-3.008 1.039-5.872 1.559-8.594 1.559zm-12.523 10.898h19.688c8.406 0 15.175-2.652 20.3-7.953 5.129-5.301 7.692-12.289 7.692-20.961 0-8.703-2.649-15.676-7.93-20.918-5.293-5.246-12.328-7.867-21.117-7.867h-18.633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.176 406.801c-4.832.09-8.731-1.582-11.692-5.008-2.957-3.43-4.437-7.852-4.437-13.273 0-5.125 1.512-9.375 4.527-12.743 3.02-3.371 6.824-5.054 11.426-5.054 4.836 0 8.734 1.66 11.711 4.992 2.973 3.316 4.461 7.707 4.461 13.156 0 5.363-1.461 9.668-4.375 12.922-2.914 3.25-6.785 4.922-11.621 5.008zm-29.09-17.93c0 8.527 2.816 15.563 8.453 21.117 5.641 5.551 12.332 8.328 20.066 8.328 8.555 0 15.629-2.789 21.223-8.375 5.598-5.578 8.395-12.632 8.395-21.156 0-8.469-2.77-15.5-8.305-21.094-5.535-5.597-12.512-8.394-20.918-8.394s-15.332 2.781-20.762 8.348c-5.437 5.57-8.152 12.644-8.152 21.226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.703 414.625v-14.062c-6.238 3.75-11.703 5.625-16.39 5.625-4.688 0-8.438-1.614-11.25-4.836-2.813-3.223-4.219-7.559-4.219-13.008 0-5.156 1.48-9.281 4.437-12.367 2.961-3.094 6.914-4.637 11.867-4.637 4.336 0 9.524 1.742 15.555 5.226v-13.972c-6.765-2.258-12.406-3.383-16.918-3.383-7.762 0-14.355 2.844-19.773 8.543-5.422 5.699-8.129 12.652-8.129 20.855 0 8.348 2.758 15.414 8.277 21.207 5.524 5.782 12.242 8.676 20.153 8.676 5.097 0 10.562-1.289 16.39-3.867"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.813 20.1836 45 45 45h237.926l107.074-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6133 22.3867-50 50-50h300c27.613 0 50 22.3867 50 50v320zm-4.141-10 104.145-104.141v-315.859c0-22.0547-17.945-40-40-40h-300c-22.0547 0-40 17.9453-40 40v380c0 22.055 17.9453 40 40 40z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d8d8d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m365 210h-245c-8.285 0-15 6.715-15 15s6.715 15 15 15h245c8.285 0 15-6.715 15-15s-6.715-15-15-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365 150h-245c-8.285 0-15 6.715-15 15s6.715 15 15 15h245c8.285 0 15-6.715 15-15s-6.715-15-15-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260 90h-140c-8.285 0-15 6.7148-15 15 0 8.285 6.715 15 15 15h140c8.285 0 15-6.715 15-15 0-8.2852-6.715-15-15-15"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.3ae347fefece636742e9d11c03e72989.svg";
export { ForwardRef as ReactComponent };